export default "__VITE_ASSET__BPgKfS3o__"